import React, { useState, useEffect } from "react";
import logo from "../../../../../assets/images/logo.png";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { useParams } from "react-router-dom";
import { createPatientGapldAction } from "../../../../../store/actions/PatientGapldAction";
import { getPatientMarriageInfo } from "../../../../../services/PatientGapldService";
import FormSuccessMessage from "../../../Common/FormSuccessMessage";
import { handleSuccess, showErrorAlert } from "../../../../../services/ErrorHandlingService";

const GapldFormPage = () => {
  const dispatch = useDispatch();
  const { patientId } = useParams();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // ✅ loader state
  const [loading, setLoading] = useState(true);

  let decodedPatientId = null;
  try {
    decodedPatientId = patientId ? atob(patientId) : null;
  } catch (err) {
    console.error("Invalid patient ID in URL:", err);
  }

  const [formData, setFormData] = useState({
    patient_id: decodedPatientId || "",
    pregnancy_status: "",
    medication: "", 
    marriage_info_id: 1,
    abortion_date: "",
    which_rx_helped: "",
    how_did_miscarriage_happen: "",
    miscarriage_reason: "",
    delivery_date: "",
    How_was_the_delivery: "",
    gender: "",
    by_patient: "YES",
  });

  const [marriageInfoList, setMarriageInfoList] = useState([]);

  const deliveryOptionList = [
    { value: "Delivered", label: "Delivered" },
    { value: "Abortion", label: "Abortion" },
    { value: "Miscarriage", label: "Miscarriage" },
  ];

  const staticMarriageHistoryOptions = [
    { value: 1, label: "1st" },
    { value: 2, label: "2nd" },
    { value: 3, label: "3rd" },
    { value: 4, label: "4th" },
    { value: 5, label: "5th" },
  ];

  const medicationOptions = [
    { value: "None", label: "None" },
    { value: "Ayurvedic", label: "Ayurvedic" },
    { value: "Allopathic", label: "Allopathic" },
    { value: "Hormonal", label: "Hormonal" },
    { value: "Other", label: "Other" },
  ];
  

  // ✅ Fetch Marriage Info
  useEffect(() => {
    if (!formData.patient_id) {
      setLoading(false);
      return;
    }

    getPatientMarriageInfo(formData.patient_id)
      .then((res) => {
        if (res.data?.status === "success") {
          const formattedOptions = res.data.data.map((item) => ({
            value: item.marriage_info_id,
            label: `${item.marriage_history} Marriage (${item.husband_or_spouse_name || "N/A"})`,
          }));
          setMarriageInfoList(formattedOptions);
        }
      })
      .catch((err) => console.error("Marriage Info fetch failed", err))
      .finally(() => setLoading(false)); // ✅ stop loader
  }, [formData.patient_id]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!decodedPatientId) {
      toast.error("Missing or invalid patient ID")
      return
    }

    if (isSubmitting) return
    setIsSubmitting(true)

    try {
      const response = await dispatch(createPatientGapldAction(formData))

      if (response?.success) {
        setIsSubmitted(true)
        //handleSuccess("GAPLD form submitted successfully!")

        // reset form
        setFormData((prev) => ({
          ...prev,
          pregnancy_status: "",
          marriage_info_id: "",
          abortion_date: "",
          which_rx_helped: "",
          how_did_miscarriage_happen: "",
          miscarriage_reason: "",
          delivery_date: "",
          How_was_the_delivery: "",
          gender: "",
        }))
      }
    } catch (err) {
      console.error("Submit error:", err)
      showErrorAlert("Failed to submit form")
    } finally {
      setIsSubmitting(false)
    }
  }

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  if (isSubmitted) {
    return (
      <FormSuccessMessage
        title="Form submitted successfully. Thank you!"
        message="Your response has been recorded successfully."
      />
    );
  }

  return (
    <div className="container py-4">
      {/* Logo */}
      <div className="text-center mb-4">
        <img src={logo} alt="Logo" style={{ width: "200px", height: "auto" }} />
      </div>

      {/* Centered and narrower form */}
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <form className="card p-4 shadow" onSubmit={handleSubmit}>
            <div className="text-center mb-4">
              <h2 className="mt-2">GAPLD Form</h2>
            </div>

            {/* Pregnancy Status */}
            <div className="mb-3">
              <label className="form-label">Pregnancy Status<span style={{ color: "red" }}>*</span></label>
              <Select
                name="pregnancy_status"
                options={deliveryOptionList}
                value={
                  formData.pregnancy_status
                    ? deliveryOptionList.find(
                      (opt) => opt.value === formData.pregnancy_status
                    )
                    : null
                }
                onChange={(selectedOption) =>
                  setFormData((prev) => ({
                    ...prev,
                    pregnancy_status: selectedOption?.value || "",
                  }))
                }
                placeholder="Select Pregnancy Status"
                isClearable
                styles={{ container: (base) => ({ ...base, width: "100%" }) }}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">
                Which Medication<span style={{ color: "red" }}>*</span>
              </label>

              <Select
                name="medication"
                options={medicationOptions}
                value={
                  formData.medication
                    ? medicationOptions.find((opt) => opt.value === formData.medication)
                    : null
                }
                onChange={(selectedOption) =>
                  setFormData((prev) => ({
                    ...prev,
                    medication: selectedOption?.value || "",
                  }))
                }
                placeholder="Select Medication"
                styles={{ container: (base) => ({ ...base, width: "100%" }) }}
                required
              />
            </div>

            {/* Marriage History (Dropdown) */}
            {/* Marriage History */}
            {/* <div className="mb-3">
              <label className="form-label">Marriage History<span style={{ color: "red" }}>*</span></label>
              <Select
                name="marriage_info_id"
                options={marriageInfoList}
                value={
                  formData.marriage_info_id
                    ? marriageInfoList.find((opt) => opt.value === formData.marriage_info_id)
                    : null
                }
                onChange={(selectedOption) =>
                  setFormData((prev) => ({
                    ...prev,
                    marriage_info_id: selectedOption?.value || "",
                  }))
                }
                placeholder="Select Marriage Info"
                isClearable
                styles={{ container: (base) => ({ ...base, width: "100%" }) }}
                required
              />
            </div> */}

            <div className="mb-3">
              <label className="form-label">
                Marriage History <span style={{ color: "red" }}>*</span>
              </label>

              <Select
                name="marriage_info_id"
                options={staticMarriageHistoryOptions}
                value={
                  staticMarriageHistoryOptions.find(
                    (opt) => opt.value === formData.marriage_info_id
                  ) || null
                }
                onChange={(selectedOption) =>
                  setFormData((prev) => ({
                    ...prev,
                    marriage_info_id: selectedOption?.value || 1, // default back to 1
                  }))
                }
                placeholder="Select Marriage History"
                isClearable={false}       // important → default stays 1st
                styles={{ container: (base) => ({ ...base, width: "100%" }) }}
                required
              />
            </div>

            {/* Abortion Section */}
            {formData.pregnancy_status === "Abortion" && (
              <>
                <div className="mb-3">
                  <label className="form-label">Abortion Date<span style={{ color: "red" }}>*</span></label>
                  <input
                    type="month"
                    className="form-control"
                    name="abortion_date"
                    value={formData.abortion_date}
                    onChange={handleChange}
                    max={new Date().toISOString().slice(0, 7)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Which RX helped to maintain pregnancy?
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="which_rx_helped"
                    value={formData.which_rx_helped}
                    onChange={handleChange}
                    placeholder="Enter treatment"
                  />
                </div>
                {/* <div className="mb-3">
                  <label className="form-label">
                    How did the miscarriage happen?
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="how_did_miscarriage_happen"
                    value={formData.how_did_miscarriage_happen}
                    onChange={handleChange}
                    placeholder="Enter details"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Miscarriage Reason</label>
                  <input
                    type="text"
                    className="form-control"
                    name="miscarriage_reason"
                    value={formData.miscarriage_reason}
                    onChange={handleChange}
                    placeholder="Enter reason"
                  />
                </div> */}
              </>
            )}

            {formData.pregnancy_status === "Miscarriage" && (
              <>
                <div className="mb-3">
                  <label className="form-label">Miscarriage Date<span style={{ color: "red" }}>*</span></label>
                  <input
                    type="month"
                    className="form-control"
                    name="abortion_date"
                    value={formData.abortion_date}
                    onChange={handleChange}
                    max={new Date().toISOString().slice(0, 7)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Which RX helped to maintain pregnancy?
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="which_rx_helped"
                    value={formData.which_rx_helped}
                    onChange={handleChange}
                    placeholder="Enter treatment"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    How did the miscarriage happen?
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="how_did_miscarriage_happen"
                    value={formData.how_did_miscarriage_happen}
                    onChange={handleChange}
                    placeholder="Enter details"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Miscarriage Reason</label>
                  <input
                    type="text"
                    className="form-control"
                    name="miscarriage_reason"
                    value={formData.miscarriage_reason}
                    onChange={handleChange}
                    placeholder="Enter reason"
                  />
                </div>
              </>
            )}

            {/* Delivery Section */}
            {formData.pregnancy_status === "Delivered" && (
              <>
                <div className="mb-3">
                  <label className="form-label">Delivery Date<span style={{ color: "red" }}>*</span></label>
                  <input
                    type="month"
                    className="form-control"
                    name="delivery_date"
                    value={formData.delivery_date}
                    onChange={handleChange}
                    max={new Date().toISOString().slice(0, 7)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">How was the delivery?</label>
                  <input
                    type="text"
                    className="form-control"
                    name="How_was_the_delivery"
                    value={formData.How_was_the_delivery}
                    onChange={handleChange}
                    placeholder="Enter delivery details"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="which_rx_helped">
                    Which RX helped to maintain pregnancy?
                  </label>
                  <input
                    id="which_rx_helped"
                    type="text"
                    className="form-control"
                    name="which_rx_helped"
                    value={formData.which_rx_helped}
                    onChange={handleChange}
                    placeholder="Enter RX"
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="gender">Gender</label>
                  <Select
                    id="gender"
                    name="gender"
                    options={[
                      { value: "Male", label: "Male" },
                      { value: "Female", label: "Female" },
                      { value: "Transgender", label: "Transgender" },
                    ]}
                    value={
                      formData.gender
                        ? { value: formData.gender, label: formData.gender }
                        : null
                    }
                    onChange={(selectedOption) =>
                      setFormData((prev) => ({
                        ...prev,
                        gender: selectedOption?.value || "",
                      }))
                    }
                    placeholder="Select Gender"
                    styles={{ container: (base) => ({ ...base, width: "100%" }) }}
                    isClearable
                  />
                </div>
              </>
            )}

            <button
              type="submit"
              className="btn btn-primary mt-3 w-100"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default GapldFormPage;
